import React, {ReactNode} from "react";
import {Icon} from "@blueprintjs/core";
import fileSize from "filesize";
import {Part} from "./types";

import "./StlFileItem.scss";

function getBasename(path: string): string {
  const matches = /[^/]+$/.exec(path);
  return matches?.[0] ?? path;
}

function formatDimensions(dimensions: string): ReactNode {
  const matches = /([0-9.]+)\s*([0-9.]+)\s*([0-9.]+)/.exec(dimensions);
  if (matches) {
    return <>
      <span className={'axis'}>x</span><span className={'measurement'}>{Number(matches[1]).toPrecision(4)}</span>
      <span className={'axis'}>y</span><span className={'measurement'}>{Number(matches[2]).toPrecision(4)}</span>
      <span className={'axis'}>z</span><span className={'measurement'}>{Number(matches[3]).toPrecision(4)}</span>
    </>
  } else {
    return dimensions;
  }
}

export const StlFileThumbnails: React.FC<{ url: string }> = ({url}) => {
  return <div className={'stl-file-thumbnails'}>
    {['front', 'side', 'top'].map(angle => {
      const _url = `${url}-${angle}.png`;
      return <a key={angle} href={_url} target={'_blank'} rel={'noreferrer'}>
        <img src={_url} alt={''}/>
      </a>;
    })}
  </div>;
};

export const StlFileItem: React.FC<{
  part: Part;
  url: string;
  active: boolean;
  view: () => void;
}> = ({part, url, active, view}) => {
  const basename = getBasename(part.path);
  return <div
    className={`stl-file-item ${active ? 'active' : ''}`}
    onClick={view}
  >
    <div className={'row top-row'}>
      <Icon icon={'cube'}/>
      <span className={'basename'}>{basename}</span>
      <span className={'filesize'}>{fileSize(part.size)}</span>
      <a
        className={'download-button'}
        href={url}
        onClick={e => {
          e.stopPropagation();
        }}
      ><Icon icon={'download'}/></a>
    </div>
    <StlFileThumbnails url={url}/>
    <div className={'row bottom-row'}>
      <Icon icon={'clip'}/>
      <div className={'dimensions'}>{formatDimensions(part.dimensions)}</div>
    </div>
  </div>;
};